var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5995 13.2V2.52002C18.4595 2.82002 20.8745 3.96002 22.8445 5.94002C24.8145 7.92002 25.9595 10.34 26.2795 13.2H15.5995ZM13.2295 26.25C10.1895 25.95 7.64453 24.67 5.59453 22.41C3.54453 20.15 2.51953 17.48 2.51953 14.4C2.51953 11.3 3.54453 8.62002 5.59453 6.36002C7.64453 4.10002 10.1895 2.82002 13.2295 2.52002V26.25ZM15.5995 26.25V15.57H26.2795C25.9995 18.43 24.8645 20.855 22.8745 22.845C20.8845 24.835 18.4595 25.97 15.5995 26.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/LiveIcon.8487e219e68811dbb6879442768d5e81.svg";
export { ForwardRef as ReactComponent };